export default __webpack_public_path__ + "static/media/Section3-img-col-dir.a0e0903a.jpg";